<div class="landing-section" [class.landing-section--action]="config.hasButton && sectionData.length !== 0">

    <div class="landing-section-title">

        <div class="landing-section-title-text rpc-title-font">
            {{config.title | translate}}
        </div>

        @if (config.hasButton && sectionData.length !== 0) {
        <rpc-button class="landing-section-title-action" [text]="'LANDING_SECTION.VIEW_ALL'" [color]="'accent'"
            [iconName]="'arrow-right'" (clicked)="onSectionButtonCliked()">
        </rpc-button>
        }

    </div>

    <div class="landing-section-block">

        @if (!isLoading) {

        @if (sectionData.length !== 0) {
        <carousel [carouselItems]="sectionData"
            [additionalButton]="config.hasButton && (isHybrid$ | async ) === false && (isMobile$ | async) === false"
            [additionalButtonText]="'LANDING_SECTION.VIEW_ALL' | translate"
            (additionalButtonClicked)="onSectionButtonCliked()">

            <ng-template #carouselItem let-carouselData>
                @switch (config.id) {
                @case (sectionName.LastViewed) {
                <gallery-listing-card [listing]="carouselData.data" [canSelect]="false"
                    [hideOpenRentals]="shouldHideOpenRentals$ | async"
                    [activitiesOrNewMatchesInLoading]="activitiesOrNewMatchesInLoading$ | async"
                    [companyConfiguration]="companyConfiguration" (activityChanged)="onActivityChanged($event)"
                    (activitiesChanged)="onActivitiesChanged($event)"
                    (mediaViewerClicked)="onMediaViewerClicked($event, carouselData.isDragging)"
                    (listingDetailsClicked)="onListingDetailsClicked($event, carouselData.isDragging)"
                    (folderClicked)="onFolderClicked(true, $event)">
                </gallery-listing-card>
                }
                @case (sectionName.Appointments) {
                <landing-appointment-card [appointmentInfo]="carouselData.data"
                    [shouldHideOpenRentals]="shouldHideOpenRentals$ | async"
                    [companyConfiguration]="companyConfiguration"
                    (mediaViewerClicked)="onMediaViewerClicked($event, carouselData.isDragging)"
                    (listingDetailsClicked)="onListingDetailsClicked($event, carouselData.isDragging)">
                </landing-appointment-card>
                }
                @case (sectionName.Messages) {
                <landing-message-card [messageInfo]="carouselData.data"
                    [shouldHideOpenRentals]="shouldHideOpenRentals$ | async"
                    [companyConfiguration]="companyConfiguration"
                    (mediaViewerClicked)="onMediaViewerClicked($event, carouselData.isDragging)"
                    (listingDetailsClicked)="onListingDetailsClicked($event, carouselData.isDragging)">
                </landing-message-card>
                }
                @case (sectionName.OpenHouses) {
                <landing-open-house-card [listing]="carouselData.data.listing" [openHouse]="carouselData.data.openHouse"
                    [shouldHideOpenRentals]="shouldHideOpenRentals$ | async"
                    [companyConfiguration]="companyConfiguration"
                    (mediaViewerClicked)="onMediaViewerClicked($event, carouselData.isDragging)"
                    (listingDetailsClicked)="onListingDetailsClicked($event, carouselData.isDragging)">
                </landing-open-house-card>
                }
                }
            </ng-template>

        </carousel>
        } @else {
        @if (config.bannerConfig != null) {
        <landing-banner [config]="config.bannerConfig" (bannerButtonClicked)="onBannerButtonClicked()">
        </landing-banner>
        }
        }

        } @else {
        <custom-spinner>
        </custom-spinner>
        }

    </div>

</div>